import { styled } from '@mui/material/styles';

export const StyledPopoverContainer = styled('div')`
  @import './../../assets/css/mixins';
  .socket-notifications {
    background: #ffffff;
    border: 1px solid #ededed;
    box-sizing: border-box;
    box-shadow: 0px 15px 36px rgba(0, 0, 0, 0.06),
      0px 3px 8px -1px rgba(50, 50, 71, 0.05);
    border-radius: 8px;
    z-index: 1;
    max-width: 277px;

    .header {
      justify-content: space-between;
      align-items: baseline;
      .label {
        color: #222222;
        font-weight: bold;
        font-size: 0.875rem;
        margin-bottom: 20px;
      }
      .empty-list-btn {
        color: #199da3;
      }
    }
    .container {
      padding: 14px 16px;
      max-height: 500px;
      overflow-y: auto;
      @include scrollbar(10);
      &:hover {
        @include scrollbar(10, #9b9ea0);
      }
    }
    .display-notification-list-btn {
      color: #199da3;
      text-align: center;
      padding: 10px;
    }
  }
`;

export const StyledTogglerWrapper = styled('div')`
  position: relative;
  cursor: pointer;
  .unseen-notification-count {
    background: #f7936f;
    border: 2px solid #ffffff;
    box-sizing: border-box;
    border-radius: 11px;
    color: #ffffff;
    position: absolute;
    left: 13px;
    top: -5px;
    height: 16px;
    font-size: 0.625rem;
    padding: 4px;
  }
`;
